module.exports = __webpack_public_path__ + "static/media/19ESCAP42.e99d47a7.jpg";